<template>
  <div>
    <!-- 银行卡管理弹框 -->
    <a-modal title="银行卡管理" :visible="visible" @cancel="handleCancel" :centered="true" width="60%">
      <div class="bank-card-manage">
        <div class="card-header">
          <a-button type="primary" @click="showBindCardDialog" icon="plus">绑定银行卡</a-button>
          <a-button type="danger" @click="handleUnbindCard" :disabled="!selectedCard" icon="delete">解绑</a-button>
        </div>
        
        <a-table 
          :columns="columns" 
          :data-source="cardList" 
          :row-key="record => record.id || record.bankCardNo"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          :pagination="false"
          size="small"
          :scroll="{ y: 300 }"
        >
          <template slot="index" slot-scope="text, record, index">
            {{ index + 1 }}
          </template>
          <template slot="majorCard" slot-scope="text">
            {{ text === '1' ? '是' : '否' }}
          </template>
        </a-table>
      </div>
      
      <template slot="footer">
        <a-button @click="handleCancel">关闭</a-button>
      </template>
    </a-modal>

    <!-- 绑定银行卡弹框 -->
    <a-modal title="绑定银行卡" :visible="bindCardVisible" @cancel="bindCardCancel" :centered="true">
      <div class="form-box">
        <a-form-model ref="bindRuleForm" :model="bindForm" :rules="bindRules" labelAlign="left">
          <a-form-model-item label="户名：">   {{selectedAccount.accountName}}
          </a-form-model-item>
          <!-- 个人 -->
          <a-form-model-item label="银行卡号:" prop="primary_account" v-if="selectedAccount.accountProperty === '1'">
            <a-input placeholder="请输入银行卡号" v-model.trim="bindForm.primary_account"></a-input>
          </a-form-model-item>
          <div v-if="selectedAccount.accountProperty === '2'">
            <!-- 企业 -->
            <a-form-model-item label="银行结算账号:" prop="primary_account2">
              <a-input placeholder="请输入银行卡号" v-model.trim="bindForm.primary_account2"></a-input>
            </a-form-model-item>
            <a-form-model-item label="开户行名称:" prop="bank_name">
              <a-input placeholder="请填写开户行名称" v-model.trim="bindForm.bank_name"></a-input>
              <a-button type="link" @click="isShowBankChoose = true" style="display: inline-block;">快速检索</a-button>
              <span style="display: inline-block;">
                <BankChoose v-if="isShowBankChoose" @changeBank="changeBank"></BankChoose>
              </span>
            </a-form-model-item>
            <a-form-model-item label="开户行行号:" prop="bank_no">
              <a-input placeholder="请输入12位开户行号, 咨询开户行" v-model.trim="bindForm.bank_no"></a-input>
            </a-form-model-item>
          </div>

          <a-form-model-item label="默认银行卡:" prop="set_default">
            <a-radio-group v-model.trim="bindForm.set_default">
              <a-radio-button value="1">
                是
              </a-radio-button>
              <a-radio-button value="0">
                否
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="短信验证码:" prop="verify_code">
            <a-input placeholder="请输入验证码" v-model.trim="bindForm.verify_code">
              <CountdownBtn slot="suffix" :wait-time="60" :error-wait-time="10" :send-call="sendVerifyCode">
              </CountdownBtn>
            </a-input>
          </a-form-model-item>
        </a-form-model>
      </div>
      <template slot="footer">
        <a-button @click="bindCardCancel">取消</a-button>
        <a-button type="primary" @click="onBindConfirmDialog">绑定</a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import CountdownBtn from "@/view/components/CountdownBtn.vue";
import BankChoose from "@/view/components/BankChoose.vue";

export default {
  name: "BankCardManage",
  components: {
    CountdownBtn,
    BankChoose
  },
  props: {
    visible: {
      required: true,
      type: Boolean
    },
    selectedAccount: {
      required: true,
      type: Object
    }
  },
  data() {
    let checkCertNum = (rule, value, callback) => {
      let custNumReg = /^62\d{14}(\d{3})?$/;
      if (value === "") {
        callback(new Error("请输入任意银行的银行卡号，仅支持16位或19位62开头的银联储蓄卡"));
      } else if (!custNumReg.test(value)) {
        callback(new Error("请输入任意银行的银行卡号，仅支持16位或19位62开头的银联储蓄卡"));
      } else {
        callback();
      }
    };

    return {
      selectedRowKeys: [],
      selectedCard: null,
      cardList: [],
      isShowBankChoose: false,
      bindCardVisible: false,
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          width: 60,
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '户名',
          dataIndex: 'custname',
          width: 100
        },
        {
          title: '银行卡号',
          dataIndex: 'bankCardNo',
          width: 180
        },
        {
          title: '银行名称',
          dataIndex: 'bankName',
          width: 120
        },
        {
          title: '银行行号',
          dataIndex: 'bankNo',
          width: 120
        },
        {
          title: '默认卡',
          dataIndex: 'majorCard',
          width: 80,
          scopedSlots: { customRender: 'majorCard' }
        }
      ],
      // 绑定表单
      bindForm: {
        primary_account: '',
        primary_account2: '',
        bank_no: '',
        bank_name: '',
        set_default: '0',
        verify_code: '',
      },
      bindRules: {
        primary_account: [
          { required: true, validator: checkCertNum, trigger: 'blur' }
        ],
        primary_account2: [
          { required: true, message: '请输入任意银行的结算账号', trigger: 'blur' }
        ],
        bank_no: [{ required: true, message: '请输入12位开户行号, 咨询开户行', trigger: 'blur' }],
        bank_name: [{ required: true, message: '请填写开户行名称', trigger: 'blur' }],
        set_default: [{ required: true, message: '请选择是否默认', trigger: 'change' }],
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.selectedRowKeys = []
        this.selectedCard = null
        this.fetchCardList()
      }
    }
  },
  methods: {
    async fetchCardList() {
      if (!this.selectedAccount?.accountNo) return
      
      const res = await this.api.bindBankCardListApi({
        accountNo: this.selectedAccount.accountNo
      })
      
      if (res.code === 200 && res.data) {
        this.cardList = res.data
      } else {
        this.cardList = []
        this.$message.error(res.info || '获取银行卡列表失败')
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedCard = selectedRows[0] || null
    },
    showBindCardDialog() {
      this.bindCardVisible = true
      this.resetBindForm()
    },
    bindCardCancel() {
      this.bindCardVisible = false
      this.resetBindForm()
    },
    resetBindForm() {
      this.bindForm = {
        primary_account: '',
        primary_account2: '',
        bank_no: '',
        bank_name: '',
        set_default: '0',
        verify_code: '',
      }
    },
    changeBank(obj) {
      this.bindForm.bank_no = obj.value
      this.bindForm.bank_name = obj['option'].componentOptions.children[0].text
      this.$nextTick(() => {
        this.$refs.bindRuleForm.validateField(['bank_name', 'bank_no'])
      })
    },
    async sendVerifyCode() {
      this.$refs.bindRuleForm.validate(async (valid) => {
        if (valid) {
          let data = {
            tradeType: 4,
            accountNo: this.selectedAccount.accountNo,
            accountName: this.selectedAccount.accountName,
            channelNo: this.selectedAccount.channelNo,
            appNo: this.selectedAccount.appNo,
            cardNo: this.selectedAccount.accountProperty === '1' ? this.bindForm.primary_account : this.bindForm.primary_account2,
            idNo: this.selectedAccount.certnum,
            mobile: this.selectedAccount.mobile
          }
          let res = await this.api.vefifycodesend(data)
          if (res.code == 200) {
            this.$message.success('发送验证码成功!')
          } else {
            return this.$message.error(res.info)
          }
        }
      })
    },
    onBindConfirmDialog() {
      this.$refs.bindRuleForm.validate((valid) => {
        if (valid) {
          if (this.bindForm.verify_code == "") {
            return this.$message.warning("请填写验证码")
          }
          this.bindBank()
        }
      })
    },
    async bindBank() {
      let paramsData = {}
      paramsData.customer_no = this.selectedAccount.custnum
      paramsData.customer_name = this.selectedAccount.custname
      paramsData.channel_no = this.selectedAccount.channelNo
      paramsData.app_no = this.selectedAccount.appNo
      paramsData.account_no = this.selectedAccount.accountNo
      paramsData.account_property = this.selectedAccount.accountProperty
      paramsData.id_no = this.selectedAccount.certnum
      paramsData.set_default = this.bindForm.set_default
      paramsData.verify_code = this.bindForm.verify_code
      paramsData.mobile = this.selectedAccount.mobile
      
      if (this.selectedAccount.accountProperty === '1') {
        paramsData.primary_account = this.bindForm.primary_account
      } else if (this.selectedAccount.accountProperty === '2') {
        paramsData.primary_account = this.bindForm.primary_account2
        paramsData.bank_no = this.bindForm.bank_no
        paramsData.bank_name = this.bindForm.bank_name
      }

      let res = await this.api.bindBankCardApi(paramsData)
      if (res.code === 200) {
        this.$message.success(res.info)
        this.bindCardVisible = false
        this.resetBindForm()
        this.fetchCardList()
        this.$emit('handleUnbindSuccess')
      } else {
        this.$message.error(res.info)
      }
    },
    handleUnbindCard() {
      if (!this.selectedCard) {
        this.$message.warning('请选择要解绑的银行卡')
        return
      }
      
      this.$confirm({
        title: '确定要解绑该银行卡吗？',
        content: () => (
          <div>
            <p>银行卡号：{this.selectedCard.bankCardNo}</p>
            <p>银行名称：{this.selectedCard.bankName}</p>
          </div>
        ),
        onOk: async () => {
          await this.unbindCard()
        },
        onCancel: () => {}
      })
    },
    async unbindCard() {
      const res = await this.api.delBankCardApi({
        channel_no: this.selectedAccount.channelNo,
        app_no: this.selectedAccount.appNo,
        account_no: this.selectedAccount.accountNo,
        primary_account: this.selectedCard.bankCardNo
      })
      
      if (res.code === 200) {
        this.$message.success(res.data || '解绑成功')
        this.fetchCardList()
        this.selectedRowKeys = []
        this.selectedCard = null
        this.$emit('handleUnbindSuccess')
      } else {
        this.$message.error(res.info || '解绑失败')
      }
    },
    handleCancel() {
      this.$emit('handleCancel')
    }
  }
}
</script>

<style lang="less" scoped>
.bank-card-manage {
  .card-header {
    margin-bottom: 16px;
    display: flex;
    gap: 10px;
  }
}

.form-box {
  padding-left: 10px;

  /deep/ .ant-form-item {
    display: flex;

    .ant-form-item-label-left {
      width: 100px;
    }

    .ant-input {
      width: 200px;
    }

    .ant-select {
      width: 200px;
    }
  }

  /deep/ .ant-input-affix-wrapper .ant-input-suffix {
    right: -120px;
  }

  .ant-input-affix-wrapper .ant-input:not(:last-child) {
    width: 200px;
  }
}
</style>
